((app) => {
    //
    // this filter allows us to dynamically pick a filter
    //
    app.filter("picker", ["$filter", ($filter) => {
        return (value, filterName, args) => {
            return filterName ? $filter(filterName)(value, args) : value;
        };
    }]);

    //
    // this filter is used to call any prebuilt angularjs filter (currency)
    //
    app.filter("filterFactory", ["$filter", ($filter) => {
        return (value, filter) => {
            let key = Object.keys(value)[0];
            return $filter(filter)(value[key]);
        };
    }]);

    app.filter("arrayData", ["$filter", ($filter) => {
        return (values, args) => {
            let key = Object.keys(values)[0];
            if(values[key]) {
                return _handleArrayData($filter, values[key], args);
            }
        };
    }]);

    app.filter("arrayPair", ["$filter", ($filter) => {
        return (values, args) => {
            let key = Object.keys(values)[0];
            if (values[key]) {
                return _handleArrayPair($filter, values[key], args);
            }
        };
    }]);

    //
    // this is a helper function that takes in array data
    // processes it into a row format with each line ending
    // in \n. Then the css is set to pre-wrap in order to
    // respect the new line.
    //
    function _handleArrayData($filter, values, args) {
        if(!args) {
            return values.join(", ");
        }
        let data = [];
        values.forEach((value, rowNumber) => {
            let row = (rowNumber + 1)+") ";
            args.forEach((arg) => {
                if(/(date)|(dob)|(on)/i.test(arg)) {
                    row += $filter("date")(value[arg]) + ", ";
                } else if (typeof value[arg] === "number") {
                    row += $filter("currency")(value[arg]) + ", ";
                } else {
                    row += value[arg] ? (value[arg] + ", ") : "";
                }
            });
            data.push(row.slice(0, -2));
        });
        return data.join("\n");
    }

    function _handleArrayPair($filter, values, args) {
        let data = [];
        let k = args[0];
        let v = args[1];
        values.forEach((value, rowNumber) => {
            let row = rowNumber + 1 + ") " + value[k] + " (";
            if (/(date)|(dob)|(on)/i.test(v)) {
                row += $filter("date")(value[v]) + "),";
            } else if (typeof value[v] === "number") {
                row += $filter("currency")(value[v]) + "),";
            } else {
                row += value[v] + "),";
            }
            data.push(row);
        });
        var join = data.join("\n");
        return join.substring(0, join.length - 1);
    }

    app.filter("cardDate", ["$filter", ($filter) => {
        return (value) => {
            let $dateFilter = $filter("date");
            for (let key in value) {
                if(/(date)|(dob)|(on)/i.test(key)) {
                    return $dateFilter(value[key]);
                }
            }
        };
    }]);

    app.filter("cardDateTime", ["$filter", ($filter) => {
        return (value) => {
            let $dateFilter = $filter("date");
            for (let key in value) {
                if (/(date)|(dob)|(on)/i.test(key)) {
                    return $dateFilter(value[key], "MMM d, yyyy h:mm:ss");
                }
            }
        };
    }]);

    app.filter("cardFullName", [() => {
        return (value) => {
            let lastname = value.LastName || "";
            let firstname = value.FirstName || "";
            let middlename = value.MiddleName || "";
            return lastname + ", " + firstname + " " + middlename;
        };
    }]);


    app.filter("percentage", () => {
        return (value) => {
            let key = Object.keys(value)[0];
            if (value[key]) {
                return value[key] + "%";
            }
        };
    });
})(window.app);
